import axios from 'axios';

import swal from "sweetalert";
import {
    loginConfirmedAction,
    logout,
} from '../store/actions/AuthActions';

const baseURL =
    process.env.REACT_APP_API_BASE_URL || 'https://staging-api.birchcoffeeapp.com';

export function login(email, password) {
    const postData = {
        email,
        password,
        // returnSecureToken: true,
    };
    return axios.post(baseURL + '/admin/auth/login', postData);
}

export function formatError(errorResponse) {
    const message =
        (typeof errorResponse === 'string' && errorResponse) ||
        errorResponse?.message ||
        errorResponse?.error ||
        errorResponse?.data?.message ||
        'Something went wrong. Please try again.';

    switch (message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            return 'Email already exists';
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           return 'Email not found';
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            return 'Invalid Password';
        case 'USER_DISABLED':
            return 'User Disabled';
        default:
            swal("Oops", message, "error",{ button: "Try Again!",});
            return message;
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
    setTimeout(() => {
        dispatch(logout(history));
    }, timer);
}

export function checkAutoLogin(dispatch, history) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(logout(history));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expires);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(logout(history));
        return;
    }
    dispatch(loginConfirmedAction(tokenDetails));
}
